import { gql } from '@apollo/client';

export const searchSuggestionsQuery = gql`
  query SearchSuggestionsV2(
    $prefix: String!
    $locale: Locale!
    $format: ArticleImageFormat
    $backend: SearchBackend
    $userAgent: String
    $userIP: String
    $thirdPartyClientId: String
    $thirdPartySessionId: String
    $urlParams: String
    $withProductSuggestions: Boolean!
  ) {
    suggestions: autoSuggestion_v2(
      prefix: $prefix
      locale: $locale
      backend: $backend
      userAgent: $userAgent
      userIP: $userIP
      thirdPartyClientId: $thirdPartyClientId
      thirdPartySessionId: $thirdPartySessionId
      urlParams: $urlParams
    ) {
      ... on SearchSuggestion {
        name
        image(format: $format)
        count: total @include(if: $withProductSuggestions)
        cioFeatureFlags {
          featureName
          featureValue
        }
      }
      ... on ProductSuggestion @include(if: $withProductSuggestions) {
        name
        productImage: image(format: $format)
        url
        sku
        parentSku
        cioFeatureFlags {
          featureName
          featureValue
        }
        prices: priceV2 {
          regular {
            value
            isRrp
          }
          special {
            value
            discount
          }
          measurement {
            value
            quantity
            unit
          }
        }
      }
    }
  }
`;
